import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Button, Collapse, FormGroup, Input, InputGroup, InputGroupAddon, Label, Navbar, NavbarToggler } from 'reactstrap';
import * as Accounts from '../store/Accounts';
import * as Localizer from '../store/Localization';
import * as paths from '../data/Paths';
import * as Records from '../store/Records';
import './NavMenu.css';

class NavMenuLeft extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    componentDidMount() {
        this.props.localizerDispatch.getAllStrings();
    }

    render() {
        console.log("NavMenuLeft render");
        const accountsState = this.props.accountsState;
        const all = "All";
        const authenticated = Accounts.authenticatedAllRoles(accountsState);
        var authenticatedRole = Accounts.accountRoles.Guest;
        const rejectedByMd = this.props.recordsState.allRejectedByMD;
        const needsOverread = this.props.recordsState.allNeedsOverread;
        const needsQa = this.props.recordsState.allNeedsQa;
        var patient = all;
        const patientInputId = "patientInput";
        const patientCode = this.props.recordsState.allPatientCode;
        const showNav = (
            authenticated &&
            accountsState.authenticatedPrivacyAccepted
        );
        var site = all;
        const siteId = this.props.recordsState.allSiteId;
        const siteInputId = "siteInput";
        const siteName = this.props.recordsState.allSiteName;
        var study = all;
        console.log("NavMenuLeft study:" + study);
        const studyId = this.props.recordsState.allStudyId;
        const studyInputId = "studyInput";
        const studyName = this.props.recordsState.allStudyName;
        const unread = this.props.recordsState.allUnread;

        if (accountsState.authenticatedAccount != null) {
            authenticatedRole = accountsState.authenticatedAccount.role;
        }

        if (patientCode !== "") {
            patient = patientCode;
        }
        if (siteName !== "") {
            site = siteName;
        }
        if (studyName !== "") {
            study = studyName;
            console.log("NavMenuLeft study:" + study + " -- changed");
        }

        const displayPatientClear = patient !== all;
        const displaySiteClear = site !== all;
        const isGuestOrPhysician = (
            authenticatedRole === Accounts.accountRoles.Guest ||
            authenticatedRole === Accounts.accountRoles.Physician
        );
        const isHcsRole = Accounts.isHcsRole(authenticatedRole);
        const studyIsAll = study === all;
        const unreadDisabled = (
            studyIsAll &&
            authenticatedRole !== Accounts.accountRoles.Physician
        );

        return (
            <Navbar className="navbar-left">
                {showNav &&
                    <div>
                    <NavbarToggler className="button" onClick={() => this.setState({ isOpen: !this.state.isOpen })}>&#9776;</NavbarToggler>
                        <Collapse isOpen={this.state.isOpen} navbar>
                            <br />
                            <FormGroup>
                                <Label for={studyInputId}>
                                    Study <Button className="button-link" disabled={isGuestOrPhysician} tag={Link} to={paths.selectStudy}>(Select)</Button>
                                </Label>
                                <Input className="input" disabled id={studyInputId} type="text" value={study} />
                            </FormGroup>
                            <FormGroup>
                                <Label for={siteInputId}>
                                    Site <Button className="button-link" disabled={studyIsAll} tag={Link} to={{ pathname: paths.selectSite, state: { studyId: studyId, studyName: studyName } }}>(Select)</Button>
                                </Label>
                                <InputGroup>
                                    <Input className="input" disabled id={siteInputId} type="text" value={site} />
                                    {displaySiteClear &&
                                        <InputGroupAddon addonType="append">
                                    <Button className="button" close="true" aria-label="Close" outline onClick={() => this.props.recordsDispatch.setAllSite("", "")}>
                                                <span aria-hidden="true">&times;</span>
                                            </Button>
                                        </InputGroupAddon>
                                    }
                                </InputGroup>
                            </FormGroup>
                            <FormGroup>
                                <Label for={patientInputId}>
                                    Patient <Button className="button-link" disabled={studyIsAll} tag={Link} to={{ pathname: paths.selectPatient, state: { siteId: siteId, siteName: siteName, studyId: studyId, studyName: studyName } }}>(Select)</Button>
                                </Label>
                                <InputGroup>
                                    <Input className="input" disabled id={patientInputId} type="text" value={patient} />
                                    {displayPatientClear &&
                                        <InputGroupAddon addonType="append">
                                    <Button className="button" close={true} aria-label="Close" outline onClick={() => this.props.recordsDispatch.setAllPatient("", "")}>
                                                <span aria-hidden="true">&times;</span>
                                            </Button>
                                        </InputGroupAddon>
                                    }
                                </InputGroup>
                            </FormGroup>
                            <div className="tab">
                                <Input className="input" checked={unread} disabled={unreadDisabled} onChange={() => this.props.recordsDispatch.setAllUnread(!unread)} type="checkbox" />{' '}
                                Unread
                            </div>
                            {isHcsRole &&
                                <div>
                                    <div className="tab">
                                        <Input className="input" checked={needsOverread} disabled={studyIsAll} onChange={() => this.props.recordsDispatch.setAllNeedsOverread(!needsOverread)} type="checkbox" />{' '}
                                        Needs Overread
                                    </div>
                                    <div className="tab">
                                        <Input className="input" checked={needsQa} disabled={studyIsAll} onChange={() => this.props.recordsDispatch.setAllNeedsQa(!needsQa)} type="checkbox" />{' '}
                                        Needs QA
                                    </div>
                                    <div className="tab">
                                        <Input className="input" checked={rejectedByMd} disabled={studyIsAll} onChange={() => this.props.recordsDispatch.setAllRejectedByMD(!rejectedByMd)} type="checkbox" />{' '}
                                        MD Rejected
                                    </div>
                                </div>
                            }
                        </Collapse>
                    </div>
                }
            </Navbar>
        );
    }
}

export default connect(
    state => ({
        accountsState: state.accounts,
        localizerState: state.localizer,
        recordsState: state.records
    }),
    dispatch => ({
        localizerDispatch: bindActionCreators(Localizer.actionCreators, dispatch),
        recordsDispatch: bindActionCreators(Records.actionCreators, dispatch)
    })
)(NavMenuLeft);



// WEBPACK FOOTER //
// ./src/components/NavMenuLeft.js